import { Box, Text, Stack, Inline } from 'braid-design-system';

import verifiedBadgeImage from '/src/images/verified-badge.svg';

import { convertSvgToBase64 } from 'src/core/utils/fileUtil';
import type { Author, CommunityGroup } from 'src/mapper/threadMapper';

interface ThreadPersonalDetailsProps {
  author: Author;
  postingDate: string;
  category?: CommunityGroup;
  showJobTitle?: boolean;
}

export default ({
  author: { avatarCharacter, avatarColor, firstName, isVerified, jobTitle },
  postingDate,
  category,
  showJobTitle = true,
}: ThreadPersonalDetailsProps) => (
  <Inline space="xxsmall" alignY="center">
    <Box
      background="customDark"
      borderRadius="full"
      padding="small"
      style={{
        backgroundColor: avatarColor,
        width: '36px',
        height: '36px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Text size="standard">{avatarCharacter}</Text>
    </Box>
    <Stack space="xxsmall">
      <Inline space="xxsmall" alignY="center">
        <Text weight="regular">
          {firstName} &#183; {postingDate}
        </Text>
        {isVerified && (
          <Box
            style={{
              width: '18px',
              height: '18px',
              border: '1px',
              backgroundImage: `url(${convertSvgToBase64(verifiedBadgeImage)})`,
            }}
          />
        )}
      </Inline>
      <Inline space="medium" alignY="center">
        {Boolean(category) && (
          <Inline space="xxsmall" alignY="center">
            <Text size="small" tone="secondary">
              in
            </Text>
            <a
              key={`personalDetails-${category?.name}-${category?.categoryId}`}
              href={category?.url}
              style={{ textDecoration: 'none' }}
            >
              <Text size="small" tone="formAccent" weight="regular">
                {category?.name}
              </Text>{' '}
            </a>
          </Inline>
        )}
        {showJobTitle && (
          <Text size="small" tone="secondary" weight="regular">
            {jobTitle}
          </Text>
        )}
      </Inline>
    </Stack>
  </Inline>
);
